module.exports = __webpack_public_path__ + "img/case-logo-25.01967a00.png";